/*------------------------------------------------
// File Name:PDM_Order.js
// File Description:PDM_Order store方法
// Author:zxl
// Create Time:2022/12/16 15:02:54
//------------------------------------------------*/

import {
    GetPDM_OrderList,
    GetPDM_OrderListByPage,
    GetPDM_OrderEntity,
    CreatePDM_OrderEntity,
    UpdatePDM_OrderEntity,
    DeletePDM_OrderEntity,
} from '@/api/pdm/order'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmOrder = {
    namespaced: true,
    state: {
        PdmOrderList: [],
        PdmOrderListLoading: false,
        PdmOrderEntity: null,
        PdmOrderShowDlg: false,
    },
    mutations: {
        setPdmOrderList(state, dataList) {
            state.PdmOrderList = [...dataList]
        },
        setPdmOrderListLoading(state, visible) {
            state.PdmOrderListLoading = visible
        },
        setPdmOrderShowDlg(state, visible) {
            state.PdmOrderShowDlg = visible
        },
        setPdmOrderEntity(state, entity) {
            state.PdmOrderEntity = entity
        },
    },
    actions: {
        //创建用户订单主表对象
        actCreatePdmOrder({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_OrderEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmOrderEntity', res.Data)
                        commit('setPdmOrderShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载用户订单主表对象
        actGetPdmOrderEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmOrderListLoading', true)
                GetPDM_OrderEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmOrderEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmOrderListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载用户订单主表列表
        actGetPdmOrderList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmOrderListLoading', true)
                GetPDM_OrderList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmOrderList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmOrderListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载用户订单主表列表
        actGetPdmOrderListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmOrderListLoading', true)
                GetPDM_OrderListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmOrderList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmOrderListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存用户订单主表信息
        actUpdatePdmOrder({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_OrderEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmOrderShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_Order
        actEditPdmOrderData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmOrderID : entity.PdmOrderID
                }
                GetPDM_OrderEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmOrderEntity', res.Data)
                        commit('setPdmOrderShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_Order ,传对象过来
        actEditPdmOrder({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmOrderEntity', entity)
                commit('setPdmOrderShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_Order
        actDeletePdmOrder({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前用户订单主表？").onOk(() => {
                    DeletePDM_OrderEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmOrderShowDlg', false)
                           
                            msg.success("删除用户订单主表成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除用户订单主表失败，原因:" + res.Message)
                            //msg.success("删除用户订单主表失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


